import { useFishDetails } from '../FishDetailsContext';
import { FaEdit } from 'react-icons/fa';
import { Card } from '@Components/Card/index';
import ShowFor from '@Components/ShowFor';
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';

export default function TagsPanel() {
  const { id, openModal, segmentsForFish, setModalContent } = useFishDetails();

  return (
    <Card className="min-h-37.5">
      <div className="mb-2 flex items-center justify-around">
        <div className="flex items-center gap-2">
          <h3 className="text-md font-semibold">Tags:</h3>
          <ShowFor permissions={['MEMBERS_WRITE']}>
            <Button
              onClick={() => {
                setModalContent('tags');
                openModal();
              }}
              className="flex items-center gap-1 text-sm"
            >
              <FaEdit size={14} />
              Manage
            </Button>
          </ShowFor>
        </div>

        <div className="flex">
          <h3 className="text-md font-semibold">Segments:</h3>
          <div className="flex items-center gap-4">
            {segmentsForFish[id] && segmentsForFish[id].length > 0 ? (
              <div className="flex flex-wrap gap-2">
                {segmentsForFish[id].map((segment) => (
                  <div
                    key={segment.id}
                    className="rounded-full bg-aoh-accent-tint px-3 py-1 text-sm font-medium text-aoh-accent dark:bg-green-900 dark:text-green-200"
                  >
                    {segment.name}
                  </div>
                ))}
              </div>
            ) : (
              <div className="pl-2">N/A</div>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
}
